import React, { useState, useEffect } from 'react';
import { api } from '../api/client';

export default function TelegramSettingsPanel() {
  const [settings, setSettings] = useState(null);
  const [botToken, setBotToken] = useState('');
  const [chatId, setChatId] = useState('');
  const [orderAlerts, setOrderAlerts] = useState(false);
  const [hourReminder, setHourReminder] = useState(false);
  const [fifteenReminder, setFifteenReminder] = useState(false);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.get('/admin/telegram-settings').then(data => {
      if (data) {
        setSettings(data);
        setChatId(data.chat_id || '');
        setOrderAlerts(data.order_alerts || false);
        setHourReminder(data.hour_reminder || false);
        setFifteenReminder(data.fifteen_reminder || false);
      }
    }).catch(() => {});
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMsg(null);
    try {
      const body = { chat_id: chatId, order_alerts: orderAlerts, hour_reminder: hourReminder, fifteen_reminder: fifteenReminder };
      if (botToken) body.bot_token = botToken;
      await api.put('/admin/telegram-settings', body);
      setMsg({ type: 'success', text: 'Saved' });
      setBotToken('');
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setSaving(false);
    }
  };

  const handleTest = async () => {
    setTesting(true);
    setMsg(null);
    try {
      const data = await api.post('/admin/telegram-test');
      setMsg({ type: data.success ? 'success' : 'error', text: data.success ? 'Test message sent!' : 'Failed to send' });
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>Telegram Notifications</h3>

      {msg && (
        <div style={{ padding: '8px 12px', borderRadius: 'var(--radius-sm)', marginBottom: 12, fontSize: 13,
          background: msg.type === 'success' ? 'rgba(72,187,120,0.1)' : 'rgba(252,129,129,0.1)',
          color: msg.type === 'success' ? 'var(--success)' : 'var(--danger)',
          border: `1px solid ${msg.type === 'success' ? 'var(--success)' : 'var(--danger)'}`,
        }}>
          {msg.text}
        </div>
      )}

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>
          Bot Token {settings?.bot_token && <span style={{ color: 'var(--text-muted)' }}>({settings.bot_token})</span>}
        </label>
        <input type="password" value={botToken} onChange={e => setBotToken(e.target.value)} placeholder="Leave blank to keep current" />
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>Chat ID</label>
        <input type="text" value={chatId} onChange={e => setChatId(e.target.value)} placeholder="-1001234567890" />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text-secondary)', cursor: 'pointer' }}>
          <input type="checkbox" checked={orderAlerts} onChange={e => setOrderAlerts(e.target.checked)} style={{ width: 'auto' }} />
          New order alerts
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text-secondary)', cursor: 'pointer' }}>
          <input type="checkbox" checked={hourReminder} onChange={e => setHourReminder(e.target.checked)} style={{ width: 'auto' }} />
          1-hour pickup reminders
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text-secondary)', cursor: 'pointer' }}>
          <input type="checkbox" checked={fifteenReminder} onChange={e => setFifteenReminder(e.target.checked)} style={{ width: 'auto' }} />
          15-min pickup reminders
        </label>
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <button className="btn-primary btn-small" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save'}
        </button>
        <button className="btn-secondary btn-small" onClick={handleTest} disabled={testing}>
          {testing ? 'Sending...' : 'Send Test'}
        </button>
      </div>
    </div>
  );
}
